const handlers: Record<string, ((...args: any[]) => void)[]> = {};

/**
 * Fire an event globally so that listeners can be set up before any class
 * is defined.
 */
export function fireGlobal(eventName: string, ...args: any[]): void {
   (handlers[eventName] || []).forEach(fn => fn(...args));
}

/**
 * Listen to an event globally so that listeners can be set up before any class
 * is defined.
 */
export function listenGlobal(eventName: string, handler: (...args: any[]) => void): void {
   (handlers[eventName] ||= []).push(handler);
}
